import type { IGeoForDesktop } from '../../../repositories/favorites/entities/favorite_entity_for_desktop/GeoForDesktop';

export const getAddressString = (address: IGeoForDesktop['address']): string | null => {
  const addressArr = address.map(({ title }) => title);

  if (!addressArr.length) {
    return null;
  }

  return addressArr.join(', ');
};
